'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineContentAdvisoryEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _simpleUgcDisplay = require('../../simple-ugc-display');

var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineContentAdvisoryEditor = exports.InlineContentAdvisoryEditor = function (_BcReactComponent) {
  _inherits(InlineContentAdvisoryEditor, _BcReactComponent);

  function InlineContentAdvisoryEditor(props) {
    _classCallCheck(this, InlineContentAdvisoryEditor);

    var _this = _possibleConstructorReturn(this, (InlineContentAdvisoryEditor.__proto__ || Object.getPrototypeOf(InlineContentAdvisoryEditor)).call(this, props));

    _this.bindAll('renderMessaging', 'renderHeading');
    _this.state = {
      focusInput: false
    };
    return _this;
  }

  _createClass(InlineContentAdvisoryEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* testing purposes */}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.showForm && nextProps.showForm) {
        this.setState({
          focusInput: true
        });
      }
    }
  }, {
    key: 'renderMessaging',
    value: function renderMessaging() {
      var _props = this.props,
          status = _props.status,
          pending = _props.pending;

      var infoMessage = _react2.default.createElement(
        _baseAlerts.AlertInfo,
        null,
        _react2.default.createElement('span', { className: 'icon-spinner' }),
        'Submitting Notice...'
      );
      var successMessage = _react2.default.createElement(
        _baseAlerts.AlertSuccess,
        null,
        'Notice Saved'
      );
      var failureMessage = _react2.default.createElement(
        _baseAlerts.AlertFailure,
        null,
        _react2.default.createElement('span', { className: 'icon-ok' }),
        'Could not save Notice.'
      );
      return _react2.default.createElement(
        'div',
        null,
        pending ? infoMessage : null,
        status === 'success' ? successMessage : null,
        status === 'failure' ? failureMessage : null
      );
    }
  }, {
    key: 'renderHeading',
    value: function renderHeading() {
      var advisoryType = this.props.advisoryType;

      var advisoryPart = '';
      if (advisoryType) {
        advisoryPart = _react2.default.createElement(_reactIntl.FormattedMessage, { id: advisoryType.toLowerCase() + '_advisory_type' });
      }
      return _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(_baseIcons.ContentAdvisory, null),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'usercontent_type_content_advisory' }),
        advisoryType ? ' - ' : null,
        advisoryPart
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          characterLimit = _props2.characterLimit,
          bibId = _props2.bibId,
          isPrivate = _props2.isPrivate,
          handlePrivacyToggle = _props2.handlePrivacyToggle,
          advisoryType = _props2.advisoryType,
          advisoryBody = _props2.advisoryBody,
          handleDelete = _props2.handleDelete,
          handleCancel = _props2.handleCancel,
          handleShowForm = _props2.handleShowForm,
          handleAdvisoryBodyChange = _props2.handleAdvisoryBodyChange,
          handleSubmit = _props2.handleSubmit,
          showForm = _props2.showForm,
          rating = _props2.rating,
          user = _props2.user;

      if (showForm) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-inline-content-advisory-editor well' },
          this.renderMessaging(),
          this.renderHeading(),
          _react2.default.createElement(_simpleUgcForm2.default, {
            characterLimit: characterLimit,
            body: advisoryBody,
            handleDelete: handleDelete,
            handleCancel: handleCancel,
            handleChange: handleAdvisoryBodyChange,
            handleSubmit: handleSubmit,
            setFocus: this.state.focusInput,
            placeholderText: advisoryType.toLowerCase() + '_field_placeholder',
            submitButtonText: 'update_content_advisory' }),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderMessaging(),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: advisoryType.toLowerCase() + '_advisory_type', values: {
            tagName: 'strong'
          } }),
        _react2.default.createElement(_simpleUgcDisplay2.default, {
          bibId: bibId,
          isPrivate: isPrivate,
          handlePrivacyToggle: handlePrivacyToggle,
          user: user,
          ugcType: 'content_advisory',
          body: advisoryBody,
          rating: rating / 2,
          handleDelete: handleDelete,
          handleShowForm: handleShowForm })
      );
    }
  }]);

  return InlineContentAdvisoryEditor;
}(_baseBcReactComponent2.default);

InlineContentAdvisoryEditor.propTypes = {
  bibId: _react.PropTypes.number.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  characterLimit: _react.PropTypes.number,
  handleSubmit: _react.PropTypes.func.isRequired,
  handleCancel: _react.PropTypes.func.isRequired,
  handleDelete: _react.PropTypes.func.isRequired,
  handleAdvisoryBodyChange: _react.PropTypes.func.isRequired,
  handleShowForm: _react.PropTypes.func.isRequired,
  initialAdvisoryBody: _react.PropTypes.string.isRequired,
  advisoryType: _react.PropTypes.string.isRequired,
  advisoryBody: _react.PropTypes.string.isRequired,
  showForm: _react.PropTypes.bool.isRequired,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }).isRequired,
  rating: _react.PropTypes.number,
  status: _react.PropTypes.string,
  pending: _react.PropTypes.bool
};

InlineContentAdvisoryEditor.defaultProps = {
  rating: 0
};

exports.default = InlineContentAdvisoryEditor;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/inline-content-advisory-editor/components/InlineContentAdvisoryEditor.js
// module id = 1023
// module chunks = 4